import * as CONST from '../../constants';

const INITIAL_STATE = { loading: true, data: null, error: null };

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case CONST.SUBSCRIPTION_EDIT_REQUEST:
      return { ...INITIAL_STATE, loading: true };
    case CONST.SUBSCRIPTION_EDIT_SUCCESS:
      return { ...INITIAL_STATE, loading: false, data: action.data };
    case CONST.SUBSCRIPTION_EDIT_ERROR:
      return { ...INITIAL_STATE, loading: false, error: action.error };
    case CONST.CLOSE_MODAL:
      return { ...INITIAL_STATE, loading: false, error: null, data: null };
    default:
      return state;
  }
};
